import React from "react";
import "../../styles/Main.css";
import "../../styles/ErrorPages.css";

export default class HomePage extends React.Component {
  render() {
    return (
      <>
        <div className="container-fluid d-flex justify-content-center align-items-center text-muted">
          <div className="fs-1 fw-bolder">404</div>
          <span className="error-divisor"></span>
          <div className="fs-3">Página não encontrada</div>
        </div>
      </>
    );
  }
}
